export const menuData  = [
    {
        key: 'nav.home',
        title:'Home',
        to:'/'
    },
    {
        key: 'nav.aboutUs',
        title:'About Us',
        to:'/about-us'
    },
    {
        key: 'nav.services',
        title:'Services',
        to:'/services'
    },
    {
        key: 'nav.pages',
        title:'Pages',
        classChange:"sub-items",
        content:[
            {
                key: 'nav.pricing',
                title:'Pricing',
                to:'/pricing'
            },
            {
                key: 'nav.team',
                title:'Team',
                to:'/team'
            },
            {
                key: 'nav.faq',
                title:'FAQ',
                to:'/faq'
            },
        ],
    },
    {
        key: 'nav.blog',
        title:'Blog',
        to:'/blog-list'
    },
    {
        key: 'nav.contactUs',
        title:'Contact Us',
        to:'/contact'
    },
]